import sortBy from "lodash/sortBy";
import { generateUniqueKeywords } from "../../../js/helpers/keywordHelpers";

export const healthcareCategoryLookup = {
  COVID_ADMIN: "Covid-19 Rapid Test Administrators",
  DENTAL: "Dentists & Orthodontists",
  DIET: "Dietitian",
  DOCTORS: "Doctors, GPs & Surgeons",
  MED_ASSISTS: "Medical Assistants",
  MED_REP: "Medical Representatives",
  MED_TECH: "Medical Technologists",
  NURSE: "Nurses & Midwives",
  OCC_THERA: "Occupational Therapists",
  PARAMEDIC: "Paramedics",
  PHARMA: "Pharmacists",
  PHARMA_TRAIN: "Pharmacists (Trainee)",
  PHYS_THERA: "Physiotherapists",
  TRAINERS: "Personal Trainers (Sports instructors)",
  HEALTH_SALES: "Sales (Nutrition & wellness)",
  SOCIAL: "Social Care",
  VET: "Veterinary",
};

const healthcareKeywords = ["health", "medic", "pharma", "physio", "doctor"];

export const PHARMACISTS_CATEGORY = "PHARMA";

export function getHealthcareCategory(category) {
  return healthcareCategoryLookup[category] || category;
}

export const HEALTHCARE_CATEGORY_LISTS = [
  ...Object.entries(healthcareCategoryLookup).map((e) => ({
    text: getHealthcareCategory([e[0]]),
    value: e[0],
  })),
];

export const PHARMA_ONLY = [
  { text: "Pharmacists", value: PHARMACISTS_CATEGORY },
];

export const DROP_DOWN_HEALTHCARE_CATEGORY_OPTIONS = [
  ...sortBy(HEALTHCARE_CATEGORY_LISTS, "text").map((item, index) => ({
    ...item,
    key: index + 1,
  })),
];

export function includesHealthcare(string) {
  const words = generateUniqueKeywords(string);

  for (const word of words) {
    if (healthcareKeywords.some((key) => word.includes(key))) {
      return true;
    }
  }
}
